export { ProfileStatusTabsComponent } from './profile-status-tabs.component'
export { ProfileStatusTab1Component } from './profile-status-tab1/profile-status-tab1.component'
export { ProfileStatusTab2Component } from './profile-status-tab2/profile-status-tab2.component'
export { ProfileStatusTab6Component } from './profile-status-tab6/profile-status-tab6.component'